export default __webpack_public_path__ + "media/images/icons_fc/doc_view-5e5846453bec6f64d169af226770deed.png";